/**
 * module-9.js
 *
 * Javascript for Module#9
 *
 * @package Wordpress/imhof-digital
 * @since   5.6.0
 * @author  Imhof Digital <info@imhof-digital.de>
 */

jQuery( document ).ready( function( $ ) {
  // declare strict mode
  'use strict';

  if( $( '.module-9' ).length > 0 ) {

      /**
       * idscript.module_9
       *
       * @since     5.6.0
       * @property  object      sliderContainer   The container of module 9 slider
       * @property  object      textContainer     The text container of module 9
       * @property  object      button            The slider button
       * @method    hideText()                    Hides the text on mobile devices by default
       * @method    slide()                       Slides the slide
       * @method    clickHandler()                Processes the clicks
       * @method    init()                        Initiate the module 9 object
       */
      idscript.module_9 = {

        /**
         * @var   object  sliderContainer
         * @since 5.6.0
         */
        sliderContainer: $( '.textslider.container' ),

        /**
         * @var   object  textContainer
         * @since 5.6.0
         */
        textContainer: '',

        /**
         * @var   object  button
         * @since 5.6.0
         */
        button: '',

        /**
         * hideText()
         *
         * Hides the text after DOM is ready
         *
         * @since 5.6.0
         */
        hideText: function() {
          if( $( window )[0].innerWidth < 1024 ) {
            idscript.module_9.textContainer = $( idscript.module_9.sliderContainer ).find( '.text' );
            $( idscript.module_9.textContainer ).css( 'marginTop', '-'+$( idscript.module_9.textContainer )[0].scrollHeight+'px' );
          } else {
            $( idscript.module_9.textContainer ).css( 'marginTop', '0px' );
            $( idscript.module_9.button ).addClass( 'closed' ).removeClass( 'open' );
          }
          return;
        },

        /**
         * slide()
         *
         * Processes the sliding
         *
         * @since 5.6.0
         */
        slide: function() {
          //check state and declare margin
          var state = $( idscript.module_9.button ).hasClass( 'open' ) ? '1.125rem' : '-'+$( idscript.module_9.textContainer )[0].scrollHeight+'px';
          $( idscript.module_9.textContainer ).animate( {
            marginTop: state
          }, 800 );
          if( state !== '1.125rem' ) {
             $( 'html, body' ).animate({
                scrollTop: ( $( '.module-9.modulecontainer' )[ 0 ].offsetTop - 72 )
             }, 1000 );
          }
          return;
        },

        /**
         * clickHandler()
         *
         * Processes clicks in module_9
         */
        clickHandler: function( e ) {
          //cross-browser capture of event-Object
          event = ( event ) ? event : window.event;
          event.preventDefault();

          if( $( idscript.module_9.button ).hasClass( 'open' ) ) {
            $( idscript.module_9.button ).removeClass( 'open' ).addClass( 'closed' );
          } else {
            $( idscript.module_9.button ).removeClass( 'closed' ).addClass( 'open' );
          }

          idscript.module_9.slide();

          return false;
        },

        /**
         * init()
         *
         * @since 5.6.0
         */
        init: function() {
          idscript.module_9.hideText();
          $( window ).on( 'resize', idscript.module_9.hideText );
          idscript.module_9.button = $( '.textslider.buttonicon' );
          $( idscript.module_9.button ).on( 'click', idscript.module_9.clickHandler );
          return;
        }
      };
      idscript.module_9.init();
  }
});
